export const iconFontAwesomeUsersPeopleUserSecret = (
	<i className="fa-solid fa-user-secret"></i>
);
